'use client';
import { Portal } from '@headlessui/react';
import { usePathname } from 'next/navigation';
import { cx } from 'react-twc';
import { useLocalStorage } from 'usehooks-ts';

import Image from '@/components/v2/Image';
import { protectedRoutes } from '@/consts/route';
import useChannelIOApi from '@/hooks/useChannelIOApi';
import { useDesktop } from '@/hooks/useMobile';
import { usePartnerConfig } from '@/providers/TenantProvider';
import { useChannelTalkVisible } from '@/store/channelTalk';

const MobileChannelTalk = () => {
  const [badge] = useLocalStorage('ch_badge', '');
  const { showMessenger } = useChannelIOApi();

  const [isChannelTalkVisible] = useChannelTalkVisible();
  const isDesktop = useDesktop();
  const pathname = usePathname();
  const config = usePartnerConfig();

  if (
    isDesktop ||
    !isChannelTalkVisible ||
    !config.features.mobileChannelTalk ||
    pathname.startsWith(protectedRoutes.root)
  )
    return null;

  return (
    <Portal>
      <div
        className={cx(
          'bottom-[16px] right-[14px] size-11 rounded-[18px] fixed z-40',
          'shadow-ch',
          'flex justify-center items-center bg-white/90',
        )}
      >
        <button id="ctk" data-gtm-id="channel" className="relative w-full" onClick={showMessenger}>
          <Image
            src={'/2025/nav/상담몽.png'}
            width={28}
            height={28}
            alt="채널톡 아이콘"
            className="m-auto"
          />{' '}
          {!!badge && Number(badge) > 0 && (
            <div className="absolute -top-2.5 -right-1 size-[17px] text-white text-[10px] rounded-full bg-cds-orange-55 border-2 border-cds-background-10 flex items-center justify-center">
              {Number(badge)}
            </div>
          )}
        </button>
      </div>
    </Portal>
  );
};

export default MobileChannelTalk;
